export default "__VITE_ASSET__asGXgHXW__"